/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Caption_GenerateInputs */

const cs_social_export_caption_generate = /** @type {(inputs: Social_Export_Caption_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generovat`)
};

const en_social_export_caption_generate = /** @type {(inputs: Social_Export_Caption_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate`)
};

/**
* | output |
* | --- |
* | "Generate" |
*
* @param {Social_Export_Caption_GenerateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_caption_generate = /** @type {((inputs?: Social_Export_Caption_GenerateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Caption_GenerateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_caption_generate(inputs)
	return cs_social_export_caption_generate(inputs)
});